import { lazy } from 'react';

// Cada módulo del sidebar se carga como un chunk aparte (React.lazy), con un
// hash propio en el nombre del archivo. Cuando se publica una versión nueva
// del front, esos hashes cambian — pero quien ya tenía la app abierta en el
// navegador sigue con el index.html/bundle viejo, que todavía apunta a los
// hashes de ANTES. Al entrar a un módulo que no había cargado aún, el
// import() dinámico pide un archivo que el servidor ya no tiene; nginx (ver
// nginx.conf, location /) cae al index.html de la SPA en vez de un 404, el
// navegador intenta interpretar ese HTML como JS ("Unexpected token '<'") y
// React tira un ChunkLoadError — sin esto, eso dejaba la pantalla en blanco.
//
// Arreglo: si el import() falla y todavía no se intentó recargar en esta
// pestaña, se fuerza una recarga completa (trae el index.html/bundle
// nuevos, con los hashes correctos) — sessionStorage evita un loop si el
// fallo fuera por otra causa real.
export function lazyWithRetry(importer) {
  return lazy(async () => {
    const key = 'lazyRetry-' + importer.toString();
    try {
      const modulo = await importer();
      sessionStorage.removeItem(key);
      return modulo;
    } catch (error) {
      const yaReintento = sessionStorage.getItem(key);
      if (!yaReintento) {
        sessionStorage.setItem(key, '1');
        window.location.reload();
        // Nunca se resuelve — la página se está recargando.
        return new Promise(() => {});
      }
      throw error;
    }
  });
}
